// extracted by mini-css-extract-plugin
export var resourceCards = "resource-cards-module--resourceCards--J1Ca8";
export var wrapper = "resource-cards-module--wrapper--cHmrG";